import dayjs from 'dayjs';
import isYesterday from 'dayjs/plugin/isYesterday';
import isToday from 'dayjs/plugin/isToday';

dayjs.extend(isYesterday);
dayjs.extend(isToday);

const removePeriods = (str) => str.replace(/\./g, '');

export const getFormattedTimestamp = (timestamp, language) => {
  const currentDate = new Date(timestamp);
  const lang = language || 'en';
  const localeConfigs = {
    en: {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    },
    fr: {
      hour: 'numeric',
      minute: 'numeric',
    },
  };

  const formatted = `${removePeriods(currentDate.toLocaleString(`${lang}-CA`, localeConfigs[lang]))}`;
  if (lang === 'fr') {
    return formatted;
  }
  return formatted.toUpperCase();
};

export const isDateYesterday = (date) => dayjs(date).isYesterday();

export const isDateToday = (date) => dayjs(date).isToday();

export const getPreviousDay = (date) => dayjs(date).subtract(1, 'day').format('YYYY-MM-DD');

export const getNextDay = (date) => dayjs(date).add(1, 'day').format('YYYY-MM-DD');

export const getMonthDayDate = (date) => dayjs(date).format('MMM D');

export const getDayMonthDate = (date) => dayjs(date).format('D MMM');

export const getDayDate = (date) => dayjs(date).format('D');

export const isDateAfter = (date) => dayjs().isAfter(date);
